
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromApp from '../store/app.reducers';


@Injectable()
export class UnavailableCartItemGuard  {

    constructor(private store: Store<fromApp.AppState>,
        private router: Router) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.store.select(fromApp.isCartItemUnavailable).pipe(map(unavailableCartItemsPresent => {
            if (unavailableCartItemsPresent) {
                this.router.navigate(['checkout']);
            }
            return !unavailableCartItemsPresent;
        }));
    }
}
